import produce from 'immer'

import { ADD_ERROR, REMOVE_ERROR } from '../actions/errors'

export default produce((draft, action) => {
  switch (action.type) {
    case ADD_ERROR:
      if (action.handledBySessionDialog) return

      draft.push(action.error as never)
      return

    case REMOVE_ERROR:
      return draft.filter((error: any) => error.id !== action.id)

    default:
      return
  }
}, [])
